import googleSignInButtonImg from '../../images/googleSignInButton.png';
import './GoogleSignInButton.css';
import {useNavigate} from "react-router";
import {IconButton} from "@mui/material";
import {FunctionComponent} from "react";
import {getAuth, GoogleAuthProvider, signInWithPopup} from "firebase/auth";
import FirebaseService from "../../services/firebaseService";


const GoogleSignInButton: FunctionComponent = () => {
    const navigate = useNavigate();

    async function signIn() {
        const provider = new GoogleAuthProvider();
        await signInWithPopup(getAuth(FirebaseService.app), provider);
        navigate('/');
    }

    return (
        <IconButton onClick={signIn}>
            <img src={googleSignInButtonImg} alt=""/>
        </IconButton>
    )
}

export default GoogleSignInButton;